import styled from 'styled-components';

export const EditWrapper = styled.div`
	display: flex;
	gap: 30px;
	justify-content: center;
`;
